import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=a76ec890&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=ts&"
export * from "./Dialog.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=a76ec890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76ec890",
  null
  
)

export default component.exports